import '../styles/styles.scss';

window.onload = async () => { 
    if (document.getElementsByClassName('menu').length) {
        await import('./menu').then((module) => module.default());
    }

    // Intro slider
    if (document.getElementsByClassName('intro-images').length) {
        await import('./introSlider').then((module) => module.default());
    }

    // Logo swiper
    if (document.getElementsByClassName('logo-swiper').length) {
        await import('./logoSwiper').then((module) => module.default());
    }

    // Facetwp template
    if (document.getElementsByClassName('facetwp-template').length) {
        await import('./facetwpScroll').then((module) => module.default());
    }
};

document.addEventListener('DOMContentLoaded', async () => {
    // Imports
});